export default __webpack_public_path__ + "static/media/marker-event.de9156ac.svg";